import React from 'react'

import { useGetDriverInfoQuery } from '../../redux/services/driver'
import { useScanMutation } from '../../redux/services/morning-scan'
import ScanResultTypes from '../../types/enum/ScanResultTypes'
import ScanResultReturnToTrunkrs from './ScanResultBackToTrunkrs'
import ScanResultError from './ScanResultError'
import ScanResultKeepOnHub from './ScanResultKeepOnHub'
import ScanResultKeepOnHubReturn from './ScanResultKeepOnHubReturn'
import { ScanResultModal } from './ScanResultModal'
import ScanResultInDayNetwork from './ScanResultInDayNetwork'

export const ScanResult: React.FC = () => {
  const [, { data, isLoading }] = useScanMutation({
    fixedCacheKey: 'scan',
  })

  const driverId = data?.shipmentData ? data.shipmentData.lastDriver : undefined

  const { data: lastDriver } = useGetDriverInfoQuery(driverId || 0, {
    skip: driverId === undefined,
  })

  if (isLoading) return null
  if (!data?.shipmentData)
    return (
      <ScanResultModal>
        <ScanResultError />
      </ScanResultModal>
    )

  if (
    data?.returnInformation &&
    data?.type === ScanResultTypes.KEEP_IN_REGION
  ) {
    return (
      <ScanResultModal>
        <ScanResultKeepOnHubReturn
          shipmentId={data.shipmentData.shipmentId}
          day={data?.returnInformation?.nextCollectionDay}
          merchantName={data?.shipmentData.sender}
          optimizationId={
            data?.returnInformation?.availableTours[0].optimizationTourId
          }
          tourTag={data?.returnInformation?.availableTours[0].tourTag}
        />
      </ScanResultModal>
    )
  }

  if (data?.type === ScanResultTypes.KEEP_IN_REGION) {
    return (
      <ScanResultModal>
        <ScanResultKeepOnHub
          address={data.shipmentData.address}
          city={data.shipmentData.city}
          postalCode={data.shipmentData.postalCode}
          sender={data.shipmentData.sender}
          tel={data.shipmentData.phoneNumber}
          lastDriver={lastDriver?.name || '--'}
        />
      </ScanResultModal>
    )
  }

  if (data?.type === ScanResultTypes.BACK_TO_TRUNKRS) {
    return (
      <ScanResultModal>
        <ScanResultReturnToTrunkrs
          address={data.shipmentData.address}
          city={data.shipmentData.city}
          postalCode={data.shipmentData.postalCode}
          sender={data.shipmentData.sender}
          tel={data.shipmentData.phoneNumber}
          lastDriver={lastDriver?.name || '--'}
        />
      </ScanResultModal>
    )
  }

  if (data?.type === ScanResultTypes.IN_DAY_NETWORK) {
    return (
      <ScanResultModal>
        <ScanResultInDayNetwork />
      </ScanResultModal>
    )
  }

  return (
    <ScanResultModal>
      <ScanResultError />
    </ScanResultModal>
  )
}

export default ScanResult
